<template>
  <header class="bg-white shadow-md">
    <nav class="container mx-auto px-2 sm:px-6 py-3 flex justify-between items-center">
      <div class="flex items-center">
        <nuxt-link :to="{ name: 'landing.home' }">
          <base-image
            :src="ImageLogo"
            title="لوگو تامینیفای"
            :width="64"
            :height="64"
            class="w-10 h-10"
          />
        </nuxt-link>

        <div class="mr-2">
          <h1 class="text-base">تامینیفای</h1>

          <p class="hidden xs:block text-xxs text-gray-500">چون سود کاسبی تو خریدشه</p>
        </div>
      </div>

      <transition-visibility>
        <div
          class="fixed left-0 top-0 w-full h-full bg-black/5 z-30"
          v-show="isSidebarShown"
        ></div>
      </transition-visibility>

      <div
        class="w-64 phone:w-auto fixed phone:static left-0 top-0 h-svh phone:h-auto transition-transform z-30 p-4 phone:p-0"
        :class="{ '-translate-x-full phone:translate-x-0': !isSidebarShown }"
      >
        <div class="h-full bg-white rounded-lg shadow-lg phone:shadow-none py-4 px-3 phone:p-0">
          <div class="flex phone:hidden items-center">
            <nuxt-link
              :to="{ name: 'landing.home' }"
              class="text-base px-3 py-2"
              @click="hideSidebar"
            >
              تامینیفای
            </nuxt-link>
          </div>

          <ul
            class="md:flex items-center phone:space-x-reverse phone:space-x-4 mt-6 phone:mt-0"
            @click.stop
          >
            <li>
              <base-dropdown>
                <button
                  type="button"
                  class="text-gray-600 hover:text-blue-500 text-sm px-3 py-2"
                >
                  دسته بندی ها
                  <base-icon
                    name="angle-up"
                    class="rotate-180 text-xxs mr-1"
                  />
                </button>

                <template #menu>
                  <!-- TODO: make this list as a tag -->
                  <base-dropdown-item
                    v-for="category in CATEGORIES"
                    :key="category.id"
                    @click="router.push(category.link)"
                  >
                    {{ category.title }}
                  </base-dropdown-item>
                </template>
              </base-dropdown>
            </li>

            <li
              v-for="page in routes"
              :key="page.name"
            >
              <nuxt-link
                :to="{ name: page.name }"
                class="block text-gray-600 hover:text-blue-500 text-sm px-3 py-2"
                @click="hideSidebar"
              >
                {{ page.meta.title }}
              </nuxt-link>
            </li>

            <li>
              <nuxt-link
                :to="URL_REGISTER"
                class="block text-gray-600 hover:text-blue-500 text-sm px-3 py-2"
                @click="hideSidebar"
              >
                فروشنده شوید!
              </nuxt-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="flex items-center">
        <!--        <base-button-->
        <!--          tag="router-link"-->
        <!--          :to="{ name: 'auth.login' }"-->
        <!--          type="primary"-->
        <!--        >-->
        <!--          ورود / ثبت نام-->
        <!--        </base-button>-->

        <base-button
          tag="router-link"
          :to="{ name: 'store.tracking' }"
          type="primary"
          class="ml-4"
          plain
          v-if="!is_tracking_page"
        >
          رهگیری
        </base-button>

        <nuxt-link
          :to="{ name: 'store.cart' }"
          class="relative flex items-center p-2"
        >
          <nuxt-icon
            name="cart"
            class="text-xl text-gray-600"
          />

          <div
            class="absolute left-0 top-0 bg-primary text-white rounded-full text-xxs px-1"
            v-if="cart_total_quantity"
          >
            {{ cart_total_quantity > 9 ? '9+' : cart_total_quantity }}
          </div>
        </nuxt-link>

        <div class="md:hidden mr-2">
          <button
            class="text-gray-600 focus:outline-none p-2"
            @click.stop="showSidebar"
          >
            <base-icon
              name="menu"
              class="text-2xl"
            />
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ImageLogo from '@/assets/images/core/logo-64.png';
import BaseImage from '~/components/base/BaseImage.vue';
import TransitionVisibility from '~/components/transitions/TransitionVisibility.vue';
import BaseButton from '~/components/base/BaseButton.vue';
import useCart from '~/assets/js/composables/cart/useCart';
import BaseDropdown from '~/components/base/dropdown/BaseDropdown.vue';
import BaseDropdownItem from '~/components/base/dropdown/BaseDropdownItem.vue';
import BaseIcon from '~/components/base/BaseIcon.vue';
import CATEGORIES from '~/assets/js/consts/categories.const';
import { URL_REGISTER } from '~/assets/js/consts/urls.const';

const route = useRoute();
const router = useRouter();
const isSidebarShown = ref(false);

const routes = computed(() => {
  return router
    .getRoutes()
    .filter(
      route =>
        (route.name?.startsWith('auth.') || route.name?.startsWith('landing.')) &&
        route.meta.headerPosition
    )
    .sort((a, b) => a.meta.headerPosition - b.meta.headerPosition);
});

const is_tracking_page = computed(() => {
  return route.path === router.resolve({ name: 'store.tracking' }).href;
});

const { cart_total_quantity } = useCart();

const showSidebar = () => {
  isSidebarShown.value = true;
  document.body.style.overflow = 'hidden';
};

const hideSidebar = () => {
  isSidebarShown.value = false;
  document.body.style.overflow = 'auto';
};

onMounted(() => {
  document.addEventListener('click', hideSidebar);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', hideSidebar);
});
</script>

<style lang="scss" scoped>
//.router-link-exact-active
.router-link-active {
  color: $color-info !important;
  text-decoration: underline;
}
</style>
